import { Button, Card, Descriptions, Skeleton, Tabs, Tag } from "antd";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import AddEditFormComponent from "../components/AddEditFormComponent";
import PurchaseOrderTableComponent from "../components/PurchaseOrderTableComponent";
import UserTableComponent from "../components/UserTableComponent";
import OrgService from "../services/Org/OrgService";

const { TabPane } = Tabs;

const SupplierEnquiryPage = () => {
  const location = useLocation();
  const [record, setRecord] = useState(null);
  const [loading, setLoading] = useState(true);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const { supplierID } = location.state || {};

  useEffect(() => {
    fetchSupplierDetails();
  }, []);

  const fetchSupplierDetails = () => {
    OrgService.fetchSupplierDetails(supplierID)
      .then((response) => {
        setRecord(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching supplier details");
        setLoading(false);
      });
  }

  const handleEditClick = () => {
    setDrawerVisible(true);
  };

  const handleCloseDrawer = () => {
    setDrawerVisible(false);
  };

  const items = [
    {
      key: '1',
      label: 'Company Name',
      children: record?.name || "N/A",
    },
    {
      key: '2',
      label: 'Email',
      children: record?.email || "N/A",
    },
    {
      key: '3',
      label: 'Phone Number',
      children: record?.phoneNumber ? `${record?.phoneCode ? ("(+" + record.phoneCode + ") ") : ""}${record.phoneNumber}` : "N/A",
    },
    {
      key: '4',
      label: 'Status',
      children: <Tag
        className={
          record?.isActive
            ? "text-white bg-primary"
            : "text-white bg-red-500"
        }
      >
        {record?.isActive ? "Active" : "Inactive"}
      </Tag>
    },
    {
      key: '5',
      label: 'Payment Terms',
      children: record?.paymentTerms || "N/A",
    },
    {
      key: '6',
      label: 'Currency',
      children: record?.currencyCd || "N/A",
    },
    {
      key: '7',
      label: 'Address',
      span: 3,
      children: record?.address
        ? `${record?.address?.addressLine1 || ""}, ${record?.address?.addressLine2 || ""}, ${record?.address?.street || ""}, ${record?.address?.city || ""}, ${record?.address?.state || ""}, ${record?.address?.zipCode || ""}`
          .replace(/, ,/g, ",")
          .replace(/(^, )|(, $)/g, "")
        : "N/A",
    },
  ];

  return (
    <div className="w-full p-3">
      <div className="w-full">
        <div className="flex justify-end items-center mb-0">
          {loading ? (
            <Skeleton active size="small" />
          ) : (
            <Button
              type="primary"
              shape="round"
              className="px-6"
              onClick={handleEditClick}
            >
              Edit
            </Button>
          )}
        </div>
        {loading ? (
          <Skeleton active size="small" />
        ) :
          <Descriptions items={items} size="small" bordered className="my-2" column={{ xs: 1, sm: 2, md: 3, lg: 3, xl: 3, xxl: 3, }} />
        }
      </div>

      <Card className="shadow-2xl">
        <Tabs centered defaultActiveKey="1">
          <TabPane key="1" tab="User">
            <UserTableComponent supplierID={supplierID} />
          </TabPane>
          <TabPane key="2" tab="Purchase Order">
            <PurchaseOrderTableComponent />
          </TabPane>
        </Tabs>
      </Card>

      <AddEditFormComponent
        open={drawerVisible}
        onClose={handleCloseDrawer}
        onSubmit={null}
        initialValues={record}
        onSuccess={fetchSupplierDetails}
        formType="supplier"
      />
    </div>
  );
};

export default SupplierEnquiryPage;